import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20abstract%20background%20with%20warm%20gradient%20tones%20of%20orange%20and%20gold%2C%20soft%20geometric%20shapes%2C%20clean%20elegant%20atmosphere%2C%20smooth%20flowing%20lines%2C%20luxury%20tech%20feel%2C%20no%20text%2C%20subtle%20depth%2C%20premium%20quality%2C%208k%20render&width=1600&height=600&seq=hero-bg-2026&orientation=landscape"
        alt="9170登录手机版入口背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
          9170登录手机版入口
        </h1>
        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          官方移动端快速登录指南，提供最新手机版登录地址、快速访问入口及常见问题解决方案。支持iOS与Android设备，一键进入，安全稳定。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/usage-guide"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200"
          >
            <i className="ri-guide-line"></i>
            查看登录教程
          </Link>
          <Link
            to="/category/faq"
            className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 px-8 py-3 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200 backdrop-blur-sm"
          >
            <i className="ri-question-answer-line"></i>
            常见问题解答
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}